import '@/lib/tiny-slider/tiny-slider.scss';
import '@/styles/vendor/fontawesome/fontawesome.scss';
import '@/styles/vendor/fontawesome/brands.scss';
import '@/styles/vendor/fontawesome/light.scss';
import '@/styles/vendor/fontawesome/regular.scss';
import '@/styles/vendor/fontawesome/solid.scss';
import '@/styles/vendor/fontawesome/thin.scss';
import '@/styles/Global/Partials/Base/Forms.scss';
import '@/styles/Global/Partials/Layout/Content.scss';
import '@/styles/Global/Partials/Layout/MobileMenu.scss';
import '@/lib/tiny-slider/tiny-slider.js';
import '@/lib/waypoints/noframework.waypoints.min.js';
import '@/lib/app.js';
import '@/scripts/Site/Header/header.js';
import '@/lib/cookies/js.cookie.min.js';
import '@/lib/Litepicker/litepicker.js';
import '@/lib/Tabs/tabs.js';
import '@/scripts/Controls/bootstrap-collapse.js';
import '@/scripts/Site/Header/tbg.acc-menu.js';

// Expose Litepicker to global for legacy scripts
declare global { interface Window { Litepicker: any } }
(window as any).Litepicker = (window as any).Litepicker;
